module.exports = __webpack_public_path__ + "img/GAME_NUMBER.dde39f6c.jpg";